import { useAppDispatch } from 'client/hooks/use-dispatch'
import { useWebsiteSettings } from 'client/store'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import React from 'react'
import { getWebsiteLayoutPageIdForLocale } from 'src/editor/shared/utils/get-website-layout-page-id'
import { setWebsiteLayoutByLocale } from 'src/editor/store/website-settings/website-settings-actions'
import {
  getCurrentWebsiteLocale,
  getWebsiteId,
  getWebsiteLayouts,
} from 'src/editor/store/website-settings/website-settings-selector'
import { WebsitePageLocale } from 'src/shared/types/website-page-interface'
import { PageElementWithActions } from './components/page-element-with-actions'

interface RenderPageSetProps {
  id: number
  pageType: PageTypeEnum
  locales: WebsitePageLocale[]
  urlPageId: string
  loadingPageId: number | null
  checkPageModification: (pageId: number, layoutPageId: number) => void
}

export const RenderPageSet = ({
  id,
  pageType,
  locales,
  urlPageId,
  loadingPageId,
  checkPageModification,
}: RenderPageSetProps) => {
  const dispatch = useAppDispatch()
  const currentWebsiteLocale = useWebsiteSettings(
    getCurrentWebsiteLocale,
  ) as PageLocaleEnum
  const websiteId = useWebsiteSettings(getWebsiteId) as number
  const websiteLayouts = useWebsiteSettings(getWebsiteLayouts) || []
  const websitePage = locales.find(
    ({ locale }) => locale === currentWebsiteLocale,
  )

  if (!websitePage) {
    return null
  }

  return (
    <PageElementWithActions
      locales={locales}
      isLoading={loadingPageId === websitePage.pageContentId}
      websiteId={websiteId}
      pageType={pageType}
      websitePageSetId={id}
      websitePageId={websitePage.id}
      websitePageLocale={websitePage.locale}
      name={websitePage?.name ?? ''}
      pageId={websitePage.pageContentId}
      isPublished={websitePage.active ?? false}
      isActive={urlPageId === websitePage.pageContentId.toString()}
      onClick={() => {
        const layoutPageId = getWebsiteLayoutPageIdForLocale({
          layouts: websiteLayouts,
          currentLocale: websitePage.locale,
        })
        if (layoutPageId) {
          dispatch(setWebsiteLayoutByLocale(websitePage.locale))
          checkPageModification(websitePage.pageContentId, layoutPageId)
        }
      }}
    />
  )
}
